import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { Providers } from './components/providers/providers.tsx'
import './styles/globals.css'
import './styles/home.css'
import './styles/hero-journey.css'
import './styles/signal-field.css'
import './styles/navigation.css'
import './styles/iphone-preview.css'

const rootElement = document.getElementById('root')!

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Providers>
          <App />
        </Providers>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app)
} else {
  ReactDOM.createRoot(rootElement).render(app)
}

/** The boot screen (index.html) stays until the display font and the first-fold images are in, so the page never repaints in front of the visitor. */
function dismissBoot() {
  const boot = document.getElementById('moova-boot')
  if (!boot) return
  const started = performance.now()
  const fonts = document.fonts
  const waits: Promise<unknown>[] = fonts
    ? [fonts.load('400 1em "Aeonik Pro"'), fonts.load('500 1em "Aeonik Pro"'), fonts.load('900 1em "Aeonik Pro"'), fonts.ready].map(promise => promise.catch(() => undefined))
    : []
  const limit = window.innerHeight * 1.6
  document.querySelectorAll('img').forEach(img => {
    if (img.complete || img.loading === 'lazy' || img.getBoundingClientRect().top > limit) return
    waits.push(new Promise(resolve => { img.addEventListener('load', resolve, { once: true }); img.addEventListener('error', resolve, { once: true }) }))
  })
  const finish = () => {
    const remaining = Math.max(0, 700 - (performance.now() - started))
    window.setTimeout(() => requestAnimationFrame(() => requestAnimationFrame(() => {
      boot.classList.add('is-done')
      boot.setAttribute('aria-busy', 'false')
      document.documentElement.classList.remove('moova-booting')
      window.setTimeout(() => boot.remove(), 600)
    })), remaining)
  }
  Promise.race([Promise.all(waits), new Promise(resolve => window.setTimeout(resolve, 4000))]).then(finish, finish)
}
requestAnimationFrame(() => requestAnimationFrame(dismissBoot))
